import { Dispatch, SetStateAction } from 'react'
import { opposite } from './opposite'

export function toggle(fn: Dispatch<SetStateAction<boolean>>): () => void {
  return () => fn(opposite)
}
